import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { LinkExternalIcon } from '@primer/octicons-react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ImageBox = makeShortcode("ImageBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`What are Primer Figma libraries?`}</h2>
    <p>{`The Primer Figma libraries contain UI components and design tokens (styles) that our teams at GitHub use to design GitHub. The components contained within Primer match what is available for developers in Primer React Components, Primer ViewComponents, and Primer CSS.`}</p>
    <h2>{`Installation`}</h2>
    <p>{`To use a library in Figma enable (install) it from the `}<strong parentName="p">{`assets`}</strong>{` tab (`}<inlineCode parentName="p">{`option`}</inlineCode>{` + `}<inlineCode parentName="p">{`2`}</inlineCode>{`).
You can also directly open the `}<em parentName="p">{`team library`}</em>{` view via the command palette or with the shortcut `}<inlineCode parentName="p">{`option`}</inlineCode>{` + `}<inlineCode parentName="p">{`cmd`}</inlineCode>{` + `}<inlineCode parentName="p">{`o`}</inlineCode>{`.`}</p>
    <ImageBox caption="Navigate to the assets tab in the left sidebar and press the book icon to open the libraries overview." mdxType="ImageBox">
  <img width="490" alt="Screenshot showing the assets tab in figma" src="https://user-images.githubusercontent.com/813754/221525999-d0278cec-d79c-40fc-8150-532f97549dc8.png" />
    </ImageBox>
    <ImageBox caption="Enable all libraries you need in your file." mdxType="ImageBox">
  <img width="443" alt="Screenshot showing the library overview in figma" src="https://user-images.githubusercontent.com/813754/221527802-76638b6b-be81-4c87-b3e8-63d543537a9c.png" />
    </ImageBox>
    <h2>{`Understanding styles`}</h2>
    <p>{`Figma libraries like `}<inlineCode parentName="p">{`Primer Primitives`}</inlineCode>{` install styles for you to use. In contrast to `}<em parentName="p">{`local styles`}</em>{` they don't show up in the sidebar.
However once you open a selection to choose a color style, text style, etc. you will see the styles from team libraries as well.`}</p>
    <p>{`To quickly find a style you can use the search box. E.g. use `}<inlineCode parentName="p">{`accent`}</inlineCode>{` to bring up all accent colors.`}</p>
    <ImageBox caption="Color style selector and color style selector with search for 'accent'" mdxType="ImageBox">
  <img width="443" alt="Screenshot showing the style selector in figma" src="https://user-images.githubusercontent.com/813754/221531315-605cba02-de29-4834-a01b-ef8dc391fe21.png" />
    </ImageBox>
    <a href="https://help.figma.com/hc/en-us/articles/360039238753-Styles-in-Figma">Learn more about Figma styles <LinkExternalIcon mdxType="LinkExternalIcon" /></a>
    <h2>{`Understanding components`}</h2>
    <p>{`At GitHub, we have created a `}<a parentName="p" {...{
        "href": "https://github.com/primer/figma/blob/main/docs/authoring-components.md"
      }}>{`set of guidelines`}</a>{` that contributors and maintainers can reference when creating and updating components.`}</p>
    <p>{`Components in our libraries have been built to be easy to understand for consumers. When possible try to keep components small and simple. Avoid advanced methods/tricks if possible. `}</p>
    <h3>{`Variants and component properties`}</h3>
    <p>{`To make components dynamic, we favor `}<a parentName="p" {...{
        "href": "https://help.figma.com/hc/en-us/articles/5579474826519-Explore-component-properties"
      }}>{`component properties `}<LinkExternalIcon mdxType="LinkExternalIcon" /></a>{` over nesting, so users don't have to override parts of a component manually. `}</p>
    <p>{`Whenever possible use components as they are without `}<em parentName="p">{`detaching`}</em>{`.`}</p>
    <a href="https://help.figma.com/hc/en-us/articles/360038662654-Guide-to-components-in-Figma">Learn more about Figma components <LinkExternalIcon mdxType="LinkExternalIcon" /></a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      